/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Aggregated authorization status across a submission's carve-out medications. "mixed" when the medications have different statuses.
 * @export
 */
export const CarveOutTrackingRowStatus = {
    Incomplete: 'incomplete',
    Ready: 'ready',
    NeedsManualSubmission: 'needs_manual_submission',
    Pending: 'pending',
    Submitted: 'submitted',
    InfoNeeded: 'info_needed',
    Failed: 'failed',
    Approved: 'approved',
    Denied: 'denied',
    Cancelled: 'cancelled',
    Expired: 'expired',
    Mixed: 'mixed',
} as const;
export type CarveOutTrackingRowStatus = typeof CarveOutTrackingRowStatus[keyof typeof CarveOutTrackingRowStatus];


export function instanceOfCarveOutTrackingRowStatus(value: any): boolean {
    for (const key in CarveOutTrackingRowStatus) {
        if (Object.prototype.hasOwnProperty.call(CarveOutTrackingRowStatus, key)) {
            if (CarveOutTrackingRowStatus[key as keyof typeof CarveOutTrackingRowStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CarveOutTrackingRowStatusFromJSON(json: any): CarveOutTrackingRowStatus {
    return CarveOutTrackingRowStatusFromJSONTyped(json, false);
}

export function CarveOutTrackingRowStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingRowStatus {
    return json as CarveOutTrackingRowStatus;
}

export function CarveOutTrackingRowStatusToJSON(value?: CarveOutTrackingRowStatus | null): any {
    return value as any;
}

export function CarveOutTrackingRowStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CarveOutTrackingRowStatus {
    return value as CarveOutTrackingRowStatus;
}

